/*
 * Project: BookingEngine
 * Module: components/icons/highlights/ServiceIcon.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';

const ServiceIcon = () => (
  <svg className="svg-icon highlight-service-icon" width="28px" height="22px" viewBox="0 0 28 22" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient x1="50%" y1="50%" x2="50%" y2="100%" id="linearGradient-1">
        <stop stopColor="#FAD961" offset="0%" />
        <stop stopColor="#F76B1C" offset="100%" />
      </linearGradient>
      <linearGradient x1="35.7142857%" y1="16.6666667%" x2="64.2857143%" y2="83.3333333%" id="linearGradient-2">
        <stop stopColor="#FAD961" offset="0%" />
        <stop stopColor="#F76B1C" offset="100%" />
      </linearGradient>
      <linearGradient x1="100%" y1="100%" x2="0%" y2="1.72254642e-14%" id="linearGradient-3">
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient x1="-1.11022302e-14%" y1="50%" x2="100%" y2="50%" id="linearGradient-4">
        <stop stopColor="#FAD961" offset="0%" />
        <stop stopColor="#F76B1C" offset="100%" />
      </linearGradient>
      <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-5">
        <stop stopColor="#000000" stopOpacity="0" offset="0%" />
        <stop stopColor="#000000" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon/facilities/services" transform="translate(-6.000000, -9.000000)">
        <g id="Group" transform="translate(6.000000, 9.000000)">
          <rect fill="#F19E1E" x="0" y="20" width="28" height="2" />
          <rect fill="#E97116" x="3" y="18" width="22" height="2" />
          <path
            d="M14,0 L14,0 C15.1045695,-2.02906125e-16 16,0.8954305 16,2 L16,3 L16,3 C15.4477153,
            3 15,3.44771525 15,4 L13,4 L13,4 C13,3.44771525 12.5522847,3 12,3 L12,2 C12,0.8954305 12.8954305,
            2.02906125e-16 14,0 Z" fill="#ED871A" />
          <path
            d="M14,0 L14,0 C15.1045695,-2.02906125e-16 16,0.8954305 16,2 L16,3 L16,3 C15.4477153,
            3 15,3.44771525 15,4 L13,4 L13,4 C13,3.44771525 12.5522847,3 12,3 L12,2 C12,0.8954305 12.8954305,
            2.02906125e-16 14,0 Z" fill="url(#linearGradient-1)" opacity="0.400000006" />
          <path
            d="M12.3245553,4 L15.6754447,4 C19.4524077,4 22.8056194,6.41685826 24,10 L25.5441518,
            14.6324555 C25.8163799,15.4491398 26.5806576,16 27.4415184,16 L28,16 L28,18 L0,18 L0,16 L0.55848156,
            16 C1.41934238,16 2.18362006,15.4491398 2.45584816,14.6324555 L4,10 C5.19438058,6.41685826 8.54759229,
            4 12.3245553,4 Z" fill="#F8E71C" />
          <path
            d="M12.3245553,4 L15.6754447,4 C19.4524077,4 22.8056194,6.41685826 24,10 L25.5441518,
            14.6324555 C25.8163799,15.4491398 26.5806576,16 27.4415184,16 L28,16 L0,16 L0.55848156,16 C1.41934238,
            16 2.18362006,15.4491398 2.45584816,14.6324555 L4,10 C5.19438058,6.41685826 8.54759229,4 12.3245553,4 Z"
            fill="url(#linearGradient-2)" opacity="0.600000024" />
          <path
            d="M11,5.5 L11.7005467,5.41243166 C12.2485667,5.34392917 12.7483569,5.73265486 12.8168593,
            6.2806748 C12.8584948,6.61375816 12.7302367,6.94551143 12.4753728,7.16396614 L11.3954988,
            8.0895725 C9.39994088,9.80005068 8.8245863,12.6491726 10,15 L4,15 L5.72524512,9.82426464 C6.50418873,
            7.48743382 8.55578545,5.80552682 11,5.5 Z" fill="url(#linearGradient-3)" />
          <polygon id="Rectangle-Copy-11" fill="url(#linearGradient-4)" opacity="0.400000006"
                   points="28 16 28 18 0 18 0 16" />
          <polygon id="Rectangle-Copy-12" fill="url(#linearGradient-5)" style={{ mixBlendMode: 'overlay' }}
                   opacity="0.400000006" points="28 20 28 22 0 22 0 20" />
          <polygon id="Rectangle-Copy-13" fill="url(#linearGradient-5)" style={{ mixBlendMode: 'overlay' }}
                   opacity="0.400000006" points="25 18 25 20 3 20 3 18" />
          <path d="M27,8 C27,4.13400675 23.8659932,1 20,1" id="Oval-4-Copy" stroke="#B8E986" strokeWidth="2" />
          <path d="M8,8 C8,4.13400675 4.86599325,1 1,1" id="Oval-4-Copy-4" stroke="#B8E986" strokeWidth="2"
                transform="translate(4.500000, 4.500000) scale(-1, 1) translate(-4.500000, -4.500000) " />
        </g>
      </g>
    </g>

  </svg>
);

export default ServiceIcon;
